<template>
  <Block type="secondary">
    <div class="flex items-center gap-2">
      <img src="/svg/eth.svg" alt="" />
      <span class="text-white">{{ tokenSymbol }} Holder Rewards</span>
    </div>
    <RewardText
      title="Overall Total Fees Earned"
      :value="`${ethRewardsTotalRewardsFormatted} ${nativeCurrencySymbol} ($${ethRewardsTotalRewardsUSDFormatted})`"
    />
    <RewardText
      title="Your Total Earned Fees"
      :value="`${ethRewardsUserTotalFormatted} ${nativeCurrencySymbol} ($${ethRewardsUserTotalUSDFormatted})`"
    />
    <RewardText
      title="Your Unclaimed Fees"
      :value="`${ethRewardsUserUnclaimedFormatted} ${nativeCurrencySymbol} ($${ethRewardsUserUnclaimedUSDFormatted})`"
    />
    <Button
      v-if="ethRewardsUserHasUnclaimed"
      text="Claim Rewards"
      secondary
      small
      class="mt-2"
      @click="claimRewards"
    />
    <Loading v-if="isProcessing" />
  </Block>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Block from "../global/Block.vue";
import Loading from "../global/Loading.vue";
import RewardText from "../rewards/RewardText.vue";
import Button from "../global/Button.vue";
export default {
  name: "RewardsBlock",
  components: {
    Block,
    Button,
    Loading,
    RewardText,
    Button,
  },

  data() {
    return {
      isProcessing: false,
    };
  },

  computed: {
    ...mapGetters([
      "ethRewardsTotalRewardsFixed",
      "ethRewardsTotalRewardsFormatted",
      "ethRewardsTotalRewardsUSDFormatted",
      "ethRewardsUserUnclaimedFixed",
      "ethRewardsUserHasUnclaimed",
      "ethRewardsUserUnclaimedFormatted",
      "ethRewardsUserUnclaimedUSDFormatted",
      "ethRewardsUserTotalFixed",
      "ethRewardsUserTotalFormatted",
      "ethRewardsUserTotalUSDFormatted",
      "nativeCurrencySymbol",
      "tokenSymbol",
    ]),
  },

  methods: {
    ...mapActions(["ethRewardsClaim"]),

    async claimRewards() {
      try {
        this.isProcessing = true;
        if (!this.ethRewardsUserHasUnclaimed) {
          return this.$notify({
            type: "error",
            text: `You don't have any unclaimed rewards!`,
          });
        }
        await this.ethRewardsClaim();
      } catch (err) {
        this.$notify({ type: "error", text: err.message });
      } finally {
        this.isProcessing = false;
      }
    },
  },
};
</script>
